export default "__VITE_ASSET__DxxFMC6K__"